import React from 'react';
import classNames from 'classnames';
import cls from './FinancialIndicatorsBlockInfo.module.css';
import { useFinancialIndicatorsBlockInfo } from './useFinancialIndicatorsBlockInfo';
import { CustomerInformationBlock } from './CustomerInformationBlock/CustomerInformationBlock';
import { BudgetInformationBlock } from './BudgetInformationBlock/BudgetInformationBlock';
import { BalanceInformationBlock } from './BalanceInformationBlock/BalanceInformationBlock';
import { ProfitForecastInformationBlock } from './ProfitForecastInformationBlock/ProfitForecastInformationBlock';

interface FinancialIndicatorsBlockInfoProps {
    classes?: string;
}

export const FinancialIndicatorsBlockInfo = ({ classes }: FinancialIndicatorsBlockInfoProps) => {
    const { is_customer } = useFinancialIndicatorsBlockInfo();
    return (
        <div className={classNames(cls.FinancialIndicatorsBlockInfo, [classes])}>
            <CustomerInformationBlock />
            {!is_customer && (
                <>
                    <BudgetInformationBlock />
                    <BalanceInformationBlock />
                    <ProfitForecastInformationBlock />
                </>
            )}
        </div>
    );
};
